import asyncWrapper from "/src/utils/asyncWrapper";

const fetchWrapper = (url, options) => asyncWrapper(fetchMethod, url, options);

const fetchMethod = (url, options) => new Promise((resolve, reject) => {
    let status;

    const { responseType = "json" } = options || {};

    fetch(url, options)
        .then(async (response) => {
            status = response.status;

            if (!response.ok) {
                const errBody = await response.text();
                return reject({ status, body: errBody });
            }

            if (responseType === "arraybuffer") {
                const data = await response.arrayBuffer();
                return resolve(data);
            }

            if (responseType === "blob") {
                const data = await response.blob();
                return resolve(data);
            }

            if (responseType === "text") {
                const data = await response.text();
                return resolve(data);
            }

            const data = await response.json();
            return resolve(data);
        })
        .catch(err => {
            if (navigator.onLine === false) return;
            reject(err);
        });
});

export default fetchWrapper;